import React from 'react';
import './Toggle.css';

/**
 * Toggle - Switch on/off reutilizable
 *
 * @param {boolean} checked - Estado actual
 * @param {function} onChange - Callback (checked) => void
 * @param {boolean} disabled - Deshabilitar interaccion
 * @param {string} size - Tamano: 'small', 'normal', 'large'
 * @param {string} className - Clase CSS adicional
 */
const Toggle = React.memo(({
  checked,
  onChange,
  disabled = false,
  size = 'normal',
  className = '',
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const sizeClass = size !== 'normal' ? `toggle--${size}` : '';

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      className={`toggle ${checked ? 'toggle--active' : ''} ${disabled ? 'toggle--disabled' : ''} ${sizeClass} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      data-sfx="button"
    >
      <span className="toggle__thumb" />
    </button>
  );
});

Toggle.displayName = 'Toggle';

export default Toggle;
